import React from 'react';
import clsx from 'clsx';
import { hasErrorCode } from '@/utils/errors';
import errorCodes from '@/constants/errors';
import NotAuthorised from '@/components/errors/NotAuthorised';
import { fetchDatasets, toggleDatasetSelected, toggleDatasetsPresentation } from '../actions';

const DatasetsPanelContainer = ({
  canRead,
  children,
  className,
  readErrors,
}) => {
  if (!canRead || hasErrorCode(readErrors, errorCodes.forbidden)) {
    return <NotAuthorised />;
  }

  return (
    <div className={clsx('aridhia-datasets-panel-container', className)}>
      { children }
    </div>
  );
};

export const mapStateToProps = ({
  auth: { role: { permissions } },
  datasets: { datasets, newDatasetCode },
  themes: { theme },
}, { category, displayAs }) => {
  const item = datasets[category];

  return {
    allowDataModelRead: permissions.datamodels.read,
    allowMultiSelect: permissions.requests.create || permissions.cohorts.read || permissions.datasets.destroy,
    allowStatus: permissions.requests.create || permissions.cohorts.create,
    canCreate: permissions.datasets.create,
    canRead: permissions.datasets.read,
    currentPage: item.currentPage,
    datasets: item.results,
    display: displayAs || item.display,
    filterTerm: item.filter,
    newDatasetCode,
    pageCount: item.totalPages,
    pageSize: item.pageSize,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    theme,
    total: item.count,
  };
};

export const mapDispatchToProps = {
  fetchData: fetchDatasets,
  onCheckBoxClick: toggleDatasetSelected,
  togglePresentation: toggleDatasetsPresentation,
};

export default DatasetsPanelContainer;
